import { featureCollection, multiLineString } from '@turf/helpers';
import { getSegments, decodeSegmentLngLat } from '../../at_map_helpers';
import { bringAtMapIntoForeground, putAtMapIntoBackground } from './at_map';
import { addPolylines, removePolylines } from './polylines';
import { addChevrons, removeChevrons } from './chevrons';
import { createDraggableMarker } from '../layers/markers';
import { closestInterpPtSegments } from '../../trail_planner/closest_on_line';

const editPolylinesId = 'editEndpoint-polylines';
const editChevronsId = 'editEndpoint-chevrons';
let draggableEndMarker;

const addEditEndpointOverlay = (map, endAtLine, handleEndpointEdited) => {
  if (!endAtLine) {
    return;
  }

  const segmentIds = [];
  const multiCoords = [];
  getSegments(endAtLine).forEach(segment => {
    segmentIds.push(segment.id);
    multiCoords.push(decodeSegmentLngLat(segment));
  });
  if (multiCoords.length === 0) {
    return;
  }
  const lastCoords = multiCoords[multiCoords.length - 1];
  if (lastCoords.length === 0) {
    return;
  }
  const lastCoord = lastCoords[lastCoords.length - 1];

  putAtMapIntoBackground(map);

  const geojson = featureCollection([multiLineString(multiCoords)]);
  addPolylines(map, editPolylinesId, geojson);
  addChevrons(map, editChevronsId, editPolylinesId);

  draggableEndMarker = createDraggableMarker('end')
    .setLngLat(lastCoord)
    .addTo(map);

  let endSegmentData;
  const onDrag = () => {
    const lngLat = draggableEndMarker.getLngLat().toArray();
    const closest = closestInterpPtSegments(lngLat, multiCoords);
    if (closest.cropIndex === null) {
      return;
    }

    // Recreate polyline from 0 to cropped end point
    const croppedMultiCoords = [];
    let newPoint; // latLng
    for (let i = 0; i < multiCoords.length; i++) {
      const coords = multiCoords[i];
      if (closest.cropSegmentsIdx === i) {
        // Crop segment
        const croppedCoords = coords.slice(0, closest.cropIndex + 1);
        if (closest.interpolatedPoint) {
          croppedCoords.push(closest.interpolatedPoint);
          newPoint = closest.interpolatedPoint.slice().reverse(); // latLng;
        }
        croppedMultiCoords.push(croppedCoords);
        // Move marker so it says on the polyline
        const endPt = croppedCoords[croppedCoords.length - 1];
        draggableEndMarker.setLngLat(endPt);
        // Break early
        break;
      }
      // Otherwise, collect coordinates from segments before cropIndex
      croppedMultiCoords.push(coords);
    }

    // Update display of polyline
    geojson.features[0].geometry.coordinates = croppedMultiCoords;
    addPolylines(map, editPolylinesId, geojson);
    addChevrons(map, editChevronsId, editPolylinesId);

    endSegmentData = {
      endSegmentId: segmentIds[closest.cropSegmentsIdx],
      endSegmentCropIndex: closest.cropIndex,
      endSegmentNewPoint: newPoint
    };
  };

  draggableEndMarker.on('drag', onDrag);
  draggableEndMarker.on('dragend', () => {
    if (!endSegmentData) {
      return;
    }
    handleEndpointEdited(endSegmentData);
    endSegmentData = null;
  });
};

const removeEditEndpointOverlay = map => {
  if (draggableEndMarker) {
    draggableEndMarker.remove();
  }

  removeChevrons(map, editChevronsId);
  removePolylines(map, editPolylinesId);

  bringAtMapIntoForeground(map);
};

export { addEditEndpointOverlay, removeEditEndpointOverlay };
